<template>
  <div>
    <div class="modal-content border-0 shadow">
      <div class="modal-body pb-5">
        <div class="col-12 col-md-9 mx-auto">
          <div class="d-flex mx-auto">
            <img
              :src="`${aws}/unicorn-feather.png`"
              class="mx-auto mb-3"
              width="150"
              height="100"
            >
          </div>
          <div class="col-12">
            <button
              type="button"
              class="btn btn-block d-flex ms-auto"
              style="position:absolute; right: 0; top: 0;"
              @click="close"
            >
              <v-icon
                icon="times"
                width="15"
                height="15"
              />
            </button>
          </div>
          <h3 class="text-center">
            Laissez-nous votre avis
          </h3>
          <div>
            <p class="text-center">
              Votre avis compte pour nous !<br>
              Si vous avez apprécié notre service,
              nous serions ravis que vous partagiez votre expérience en laissant un avis sur
              Google.
            </p>
          </div>

          <a
            href="https://g.page/r/CWrsZ4jHYBX0EBM/review"
            target="_blank"
            class="btn btn-primary w-100"
            @click="close"
          >
            Je donne mon avis
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { transform, ui } from '@/mixins';

export default {
  mixins: [transform, ui],
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  methods: {
    close() {
      this.ui_showModal(false);
    },
  },
};

</script>
